import { Circle, MapContainer, Marker, TileLayer } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const pin = L.divIcon({ className: "site-pin", html: "<span></span>", iconSize: [22, 22], iconAnchor: [11, 11] });

export function LocationMap({ lat, lng, exact, height = 320, testid = "location-map" }) {
  return (
    <div className="rounded-2xl overflow-hidden border border-slate-200 relative z-0" style={{ height }} data-testid={testid}>
      <MapContainer center={[lat, lng]} zoom={exact ? 16 : 14} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {exact ? <Marker position={[lat, lng]} icon={pin} /> : <Circle center={[lat, lng]} radius={450} pathOptions={{ color: "#f97316", fillColor: "#f97316", fillOpacity: 0.18, weight: 2 }} />}
      </MapContainer>
    </div>
  );
}
